// Groups cart items that share the same design (ignoring size) into a "size run"
// summary, so multi-size orders are easy to read and pack.

const SIZE_ORDER = ["XS", "S", "M", "L", "XL", "2X", "3X", "4X", "5X"];

const designSignature = (it) => {
  const c = it.customization || {};
  return JSON.stringify({
    p: it.product_id,
    color: c.color_name || "",
    preset: c.preset_name || "",
    text: c.custom_text || "",
    img: c.custom_image_data ? "img" : "",
    layers: (c.layers || []).map((l) => ({ t: l.type, s: l.src || "", x: l.text || "", col: l.color || "" })),
  });
};

const sortSizes = (a, b) => {
  const ia = SIZE_ORDER.indexOf((a.size || "").toUpperCase());
  const ib = SIZE_ORDER.indexOf((b.size || "").toUpperCase());
  return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
};

// Returns only groups that span 2+ separate size lines (a genuine size run).
export function buildSizeRuns(items) {
  const groups = new Map();
  for (const it of items) {
    const sig = designSignature(it);
    if (!groups.has(sig)) {
      const c = it.customization || {};
      const descriptor = [c.color_name, c.preset_name, c.custom_text ? `"${c.custom_text}"` : null, c.custom_image_data ? "Custom Upload" : null]
        .filter(Boolean)
        .join(" · ");
      groups.set(sig, { key: sig, product_name: it.product_name, descriptor, sizes: [], totalQty: 0 });
    }
    const g = groups.get(sig);
    g.sizes.push({ size: it.customization?.size || "One size", qty: it.quantity });
    g.totalQty += it.quantity;
  }
  return [...groups.values()]
    .filter((g) => g.sizes.length > 1)
    .map((g) => ({ ...g, sizes: g.sizes.sort(sortSizes) }));
}
